import React from 'react'
import { useIntl } from 'react-intl'

import { CardStateAction } from './card-state-action'

import type { FeatureInterest } from '../../hooks/use-feature-interest'

export interface NotifyMeProps {
  interest: FeatureInterest
}

/** The right end of a Coming soon card's title line: ask to be told, or see that you will be, and undo it. */
export function NotifyMe({ interest }: NotifyMeProps): React.ReactElement {
  const { formatMessage } = useIntl()
  const { on, name, onToggle } = interest

  return (
    <CardStateAction
      done={on}
      label={formatMessage({ id: on ? 'catalogCard.notifyMeOnLabel' : 'catalogCard.notifyMeLabel' }, { name })}
      text={formatMessage({ id: on ? 'catalogCard.notifyMeOn' : 'catalogCard.notifyMe' })}
      onClick={onToggle}
    />
  )
}

export default NotifyMe
